import { openTasksView } from '../actions/publicActions';
import { updateCurrentView } from '../actions/timePanelStoreActions';
import { verifyValidSource } from '../utils/verifyValidSource';
import { openTimePanel, popView } from 'owa-time-panel-bootstrap';
import { getStackLength } from 'owa-time-panel-view-stack';
import { LazyInitializeQuickAdd } from 'owa-todos';
import { orchestrator } from 'satcheljs';

export const openTasksViewOrchestrator = orchestrator(openTasksView, actionMessage => {
    const { source, taskSubject, taskLinkedEmailId, extractionId } = actionMessage;

    // verify source for telemetry purposes
    if (!verifyValidSource(source)) {
        return;
    }

    // make sure panel is open
    openTimePanel(source);

    // close all non-base views
    while (getStackLength() > 1) {
        popView();
    }

    // open directly to Tasks view
    updateCurrentView('Tasks');

    // pre-populate Task panel with detected task intent (if any)
    if (taskSubject && taskLinkedEmailId) {
        LazyInitializeQuickAdd.importAndExecute(taskSubject, taskLinkedEmailId, extractionId);
    }
});
